module.exports = __webpack_public_path__ + "res/33-img_game_uscore.a312ced60ab77d16a1d40ea52d86131f.png";